/**
 * examBank.js
 * The final examination question bank for the MbuziPlus Course.
 * It is built from every module quiz (10 questions per module, all 8 parts),
 * the two original modules' quizzes, and the original 20 exam questions.
 * Each attempt draws EXAM_SIZE questions: at least two from every module so the
 * whole journey is tested, the rest at random, then shuffled.
 */
import { GENERIC } from "./modules";
import { QUIZ as BREED_QUIZ } from "./BreedSelection.jsx";
import { QUIZ as ANATOMY_QUIZ } from "./DairyGoatAnatomy.jsx";
import { CORE_EXAM } from "./examCore";
import { shuffle, mulberry32 } from "./shuffle";
export { optionOrder } from "./shuffle";

export const EXAM_SIZE = 100;
const PER_MODULE = 2;
const SKIP = /best way to use what this module teaches/i;

const norm = (q, moduleId, part) => ({
  q: q.q,
  options: q.options,
  answer: typeof q.correct === "number" ? q.correct : q.answer,
  why: q.why || "",
  moduleId,
  part,
});

export function buildBank() {
  const bank = [];
  Object.values(GENERIC).forEach((m) => {
    (m.quiz || []).forEach((q) => { if (!SKIP.test(q.q)) bank.push(norm(q, m.id, partOf(m.no))); });
  });
  BREED_QUIZ.forEach((q) => bank.push(norm(q, "breed-selection", 1)));
  ANATOMY_QUIZ.forEach((q) => bank.push(norm(q, "anatomy", 1)));
  CORE_EXAM.forEach((q) => bank.push(norm(q, "core", 0)));
  // Drop exact duplicate questions
  const seen = new Set();
  return bank.filter((x) => { const k = x.q.trim().toLowerCase(); if (seen.has(k)) return false; seen.add(k); return true; });
}

function partOf(no) {
  if (no <= 5) return 1; if (no <= 9) return 2; if (no <= 15) return 3; if (no <= 21) return 4;
  if (no <= 24) return 5; if (no <= 33) return 6; if (no <= 39) return 7; return 8;
}

export function drawExam(seed, size = EXAM_SIZE) {
  const rnd = mulberry32(seed);
  const bank = buildBank();
  const byModule = {};
  bank.forEach((x) => { (byModule[x.moduleId] = byModule[x.moduleId] || []).push(x); });
  const picked = [];
  const used = new Set();
  Object.keys(byModule).filter((k) => k !== "core").forEach((k) => {
    shuffle(byModule[k], rnd).slice(0, PER_MODULE).forEach((x) => { picked.push(x); used.add(x.q); });
  });
  const rest = shuffle(bank.filter((x) => !used.has(x.q)), rnd);
  while (picked.length < size && rest.length) picked.push(rest.shift());
  // Shuffle the options of every question too, so the right answer is not always in the same place.
  return shuffle(picked.slice(0, size), rnd).map((x) => {
    const order = shuffle(x.options.map((_, k) => k), rnd);
    return { ...x, options: order.map((k) => x.options[k]), answer: order.indexOf(x.answer) };
  });
}

export const BANK_SIZE = buildBank().length;
